
	import { Options, Vue } from "vue-property-decorator";
	import WaitingRoomOverlay from "@/views/patient_user/telehealth/components/WaitingRoomOverlay.vue";

	@Options({})
	export default class PublicWaitingRoomOverlay extends WaitingRoomOverlay
	{

	}
